<div class="main-panel">
  <div class="main-panel__container">
    <evc-header class="main-panel__header"></evc-header>
    <ng-content />
  </div>
</div>
